import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  ${({ theme: { colors } }) => css`
    grid-column: 1;
    grid-row: 2;
    margin-top: 1.2rem;
    padding-top: 1.2rem;

    // Subtle divider line
    border-top: 1px solid ${colors.neutral.grey};
    animation: fadeIn 0.3s ease-in-out;

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(-0.5rem);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `}
`;

const Text = styled.p`
  ${({ theme: { colors, tp } }) => css`
    ${tp.p1};
    color: ${colors.primary.dark};
    margin: 0;
    opacity: 0.64;
  `}
`;

interface ITranslatedText {
  translation: string;
}

const TranslatedText: React.FC<ITranslatedText> = ({ translation }) => {
  return (
    <Wrapper>
      <Text>{translation}</Text>
    </Wrapper>
  );
};

export default TranslatedText;